import { trpc } from '@klear/ui/lib/trpc'
import { useMutationWithToast, createToastConfig } from '@klear/ui/hooks/use-mutations-with-toast'

export function useOrder(id: number, options?: { enabled?: boolean; traderId?: number }) {
  const {
    data: order,
    error,
    isLoading
  } = trpc.order.get.useQuery(
    { orderId: id, ...(options?.traderId && { traderId: options.traderId }) },
    {
      enabled: !!id && options?.enabled !== false
    }
  )

  return { order, error, isLoading }
}

const invalidateQueries = ['order.list', 'order.get']

export function useOrderMutations() {
  const createOrderMutation = useMutationWithToast(
    trpc.order.create.useMutation,
    createToastConfig('Order', 'create'),
    {
      invalidateQueries
    }
  )

  const deleteOrderMutation = useMutationWithToast(
    trpc.order.delete.useMutation,
    createToastConfig('Order', 'delete'),
    {
      invalidateQueries
    }
  )

  const setArchivedMutation = useMutationWithToast(
    trpc.order.setArchived.useMutation,
    createToastConfig('Order', 'update'),
    {
      invalidateQueries
    }
  )

  return {
    createOrder: async (data: { customerId: number; description?: string; traderId: number }) => {
      return await createOrderMutation.mutateAsync({
        traderId: data.traderId,
        data: { customerId: data.customerId, description: data.description }
      })
    },
    deleteOrder: async (data: { orderId: number; traderId: number }) => {
      const result = await deleteOrderMutation.mutateAsync(data)
      return result ?? null
    },
    setOrderArchived: async (data: { orderId: number; isArchived: boolean; traderId?: number }) => {
      const result = await setArchivedMutation.mutateAsync(data)
      return result ?? null
    },
    isCreating: createOrderMutation.isPending,
    isDeleting: deleteOrderMutation.isPending,
    isArchiving: setArchivedMutation.isPending
  }
}
